import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import { ProductSetupRequest } from '../../../api/models/product-setup-request';
import { FormGroup, FormBuilder, Validators } from '../../../../node_modules/@angular/forms';
import { ProductAliasService } from '../../../api/services/product-alias.service';
import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from '../../../api/services/preferences.service';
import { AuthService } from '../../../api/services/auth.service';

@Component({
  selector: 'app-product-setup-request-add',
  templateUrl: './product-setup-request-add.component.html',
  styleUrls: ['./product-setup-request-add.component.scss']
})
export class ProductSetupRequestAddComponent {

  productRequestForm: FormGroup;
  newProductRequest: ProductSetupRequest = new ProductSetupRequest();
  marketId: string;
  // tslint:disable-next-line:max-line-length
  placerholderText= 'Please provide a detailed description of the product information you need added to the product database and it will be reviewed by a Tessco Employee (Maximun characters: 255).';
  loading = false;
  disableSaveButton : boolean = false;
  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private productService: ProductAliasService,
    private toastr: ToastrService,
    private preferencesService: PreferencesService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.productRequestForm = this.formBuilder.group({
      manufacturer: [this.newProductRequest.manufacturer, Validators.compose([Validators.required, Validators.maxLength(255)])],
      manufacturerPartNumber: [this.newProductRequest.manufacturerPartNumber, Validators.compose([Validators.required, Validators.maxLength(255)])],
      productDescription: [this.newProductRequest.productDescription, Validators.compose([Validators.required, Validators.maxLength(255)])],
      comments: [this.newProductRequest.comments, Validators.compose([Validators.maxLength(255)]) ]
    });
  }

  get productDescription() { return this.productRequestForm.get('productDescription'); }
  get manufacturer() { return this.productRequestForm.get('manufacturer'); }
  get manufacturerPartNumber() { return this.productRequestForm.get('manufacturerPartNumber'); }
  get comments() { return this.productRequestForm.get('comments'); }

  submitProductSetupRequest() {
    this.disableSaveButton = true;
    this.loading = true;
    this.newProductRequest.productDescription = this.productDescription.value;
    this.newProductRequest.manufacturer = this.manufacturer.value;
    this.newProductRequest.manufacturerPartNumber = this.manufacturerPartNumber.value;
    this.newProductRequest.comments = this.comments.value;
    this.preferencesService.getPreferences('USER', this.authService.getUserId()).subscribe(prefs => {
      this.newProductRequest.marketId =  prefs['current-market'].Value;
      this.sendProductSetpRequest();
    });
  }

  private sendProductSetpRequest() {
    this.productService.createProductRequest(this.newProductRequest).subscribe(() => {
      this.activeModal.close();
      this.onUpdateSuccess();
      this.loading = false;
      this.disableSaveButton = false;
    }, error => {
      this.loading = false;
      this.disableSaveButton = false;
      this.activeModal.close();
      const message = error.error.message;
      if (message && message != null) {
        this.onUpdateFailure(message);
      } else {
        this.onUpdateFailure('Product Set Up request could not be sent!!!');
      }
    });
  }

  private onUpdateSuccess() {
    this.toastr.success('Product Set Up request sent successfully!!!', 'OK!', {
      timeOut: 3000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateFailure(errorMessage: string) {
    this.toastr.error(errorMessage, 'Error!', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/product-alias/product-setup-request-add/product-setup-request-add.component.ts